import './polyfills/polyfills.js';
import App from '../app';
import { initializeIcons } from '@uifabric/icons';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from '../store/';
import { enableES5 } from 'immer';
import { initLogger, logger } from '../helpers/logger';

enableES5();
initializeIcons();

const render = (Component: typeof App) => {
    console.log('start reder');
    // eslint-disable-next-line react/no-deprecated
    ReactDOM.render(
        <React.StrictMode>
            <Provider store={store}>
                <Component
                    isOfficeInitialized={true}
                    location={window.location}
                />
            </Provider>
        </React.StrictMode>,
        document.getElementById('container'),
    );
};

(async () => {
    try {
        await initLogger();
        logger.info('Logger initialized', 'Logger');
    } catch (error) {
        console.error('Failed to initialize logger:', error);
    }
    logger.debug(`window.location.href = ${window.location.href}`, 'Init');
    render(App);
})();
